import React from 'react';
import css from './OffsiteConstruction.module.css';
import { NamedLink } from '../../../components';
import Icons from '../../../components/Icons/Icons';

function OffsiteConstruction(props) {
  const { intl } = props;
  return (
    <div className={css.offsiteConstruction}>
      <div className={css.fixedWidthContainer}>
        <div className={css.mainTitle}>
          <h2>{intl.formatMessage({ id: 'CustomerLandingPage.Offsite.Title' })}</h2>
          <p>
            {intl.formatMessage({ id: 'CustomerLandingPage.Offsite.Description' })}&nbsp;
            <NamedLink className={css.learnMore} name="CustomOffsiteConstructionPage">
              {intl.formatMessage({ id: 'CustomerLandingPage.Offsite.LearnMore' })}{' '}
              <Icons name="rightArrow" />
            </NamedLink>
          </p>
        </div>
        <div className={css.timelineSec}>
          <h4>{intl.formatMessage({ id: 'CustomerLandingPage.Timeline.Title' })}</h4>
          <div className={css.startCheck}>
            <div className={css.checkStep}>
              <h2>Start with an Affordability Check</h2>
            </div>
            <div className={css.checkStep}>
              <h2>Land Acquisition</h2>
              <p>3 months to 24 months (depending on preferences, location and availability)</p>
            </div>
            <div className={css.checkStep}>
              <h2>Design & Planning Permission</h2>
              <p>3 months to 9 months (depending on site constraints and response time)</p>
            </div>
            <div className={css.checkStep}>
              <h2>Building Regulations</h2>
              <p> 2 to 4 weeks</p>
            </div>
            <div className={css.checkStep}>
              <h2>Contractor Pricing</h2>
              <p> 2 to 4 weeks</p>
            </div>
            <div className={css.middleStep}>
              <div className={css.checkStep}>
                <h2>Site Prep/Groundworks</h2>
                <p> 6 to 8 weeks</p>
              </div>
              <div className={css.checkStep}>
                <h2>Factory Assemble</h2>
                <p> 6 to 8 weeks</p>
              </div>
            </div>

            <div className={css.checkStep}>
              <h2>Install factory built house</h2>
              <p> 1 to 3 weeks</p>
            </div>

            <div className={css.checkStep}>
              <h2>Finishes, internal plus landscaping</h2>
              <p> 1 to 3 months</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OffsiteConstruction;
